import(/* webpackMode: "eager" */ "/src/src/app/(staitc-page)/packaging/packaging.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/components/Image/index.tsx");
